import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,_vm._b({staticClass:"lockable-card"},'v-card',_vm.$attrs,false),[_vm._t("default"),(_vm.locked)?_c('div',{staticClass:"locked-overlay"},[_c('div',{staticClass:"locked-message"},[_vm._v(" Please wait until upload is completed ")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }